import PropTypes from 'prop-types';
import React from 'react';
import Spinner from './Spinner';
import { getComponentClasses } from '@99designs/utils/app';

export default class LoadableElement extends React.Component {
    render() {
        var classes = getComponentClasses('loadable-element', this.props.variations);

        if (this.props.isLoading) {
            return (
                <div className={classes}>
                    <div className="loadable-element__spinner">
                        <Spinner variations={this.props.spinnerVariations} />
                    </div>
                </div>
            );
        } else {
            return this.props.children;
        }
    }
}

LoadableElement.propTypes = {
    isLoading: PropTypes.bool,
    variations: PropTypes.array,
    spinnerVariations: PropTypes.array,
};

LoadableElement.defaultProps = {
    isLoading: false,
    variations: [],
    spinnerVariations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/LoadableElement.jsx